module.exports = __webpack_public_path__ + "img/follow.6d00227c.svg";